import React, { useState, createContext, useContext, useEffect } from 'react';
import { getFirestore, collection, getDocs, doc, setDoc} from 'firebase/firestore';
import { getStorage, ref, uploadBytes, getDownloadURL, listAll, getMetadata } from "firebase/storage";

const AdminContext = createContext([])

export const useAdminContext = () => useContext(AdminContext)


const AdminContextProvider = ({ children }) => {

    const db = getFirestore()
    const [url, setUrl] = useState(null);
    const [uploadingZip, setUploadingZip] = useState(false);
    const [uploading, setUploading] = useState(false)

    const [addError, setAddError] = useState(false)
    const [added, setAdded] = useState(false)
    const storage = getStorage();
    //// SHOP
  
    const [image, setImage] = useState(null);
    const [errorShop, setErrorShop] = useState(false);
    const [uploadingShop, setUploadingShop] = useState(false);
    const [uploadedShop, setUploadedShop] = useState(false);
    const [bigImg, setBigImg] = useState(false);
    const [metadatas, setMetadatas] = useState({});
  
    const [alreadyExists, setAlreadyExists] = useState(false);
    const handleChange = (e) => {
      if (e.target.files[0] && e.target.files[0].size < 5000000) {
        setImage(e.target.files[0]);
      } else {
        setBigImg(true);
  
        setTimeout(() => {
          setBigImg(false);
        }, 4000);
      }
    };
  

    const [render, setRender] = useState(false)


    const rerender = () => {
      if(render === true) {
        setRender(false)
      } else {
        setRender(true)
      }
     }
  
    // useEffect(() => {
    //   const QueryCollection = collection(db,`orders`)
  
    //   getDocs(QueryCollection)
    //     .then(resp => setContextOrders(resp.docs.map(book => ({ id: book.id, ...book.data() }))))
    //     .catch((err) => console.log(err))
  
    //  }, [render])

    
    const [metadatasShop, setMetadatasShop] = useState({})

    const handleUploadShopImage = () => {
        setUploadingZip(true)
        const storageRef = ref(storage, `shop/${image.name}`)
        getMetadata(storageRef)
            .then(metadata =>
                // El archivo ya existe, hacer algo aquí
                setAlreadyExists(true), setTimeout(() => { setAlreadyExists(false) }, 4000)
            )
            .catch(error => {
                if (error.code == "storage/object-not-found") {
                    // El archivo no existe, cargarlo aquí
                    setUploadingShop(true)
                    uploadBytes(storageRef, image).then(
                        metadata => {
                            setMetadatasShop(metadata)
                        }
                    ).then(() => {
                        if (metadatas) {
                            getDownloadURL(storageRef)
                                .then(url => setUrl(`${url}`))
                                .then(() => setUploadedShop(true))
                                .then(() => setUploadingZip(false)
                            )
                                .catch(error => console.log(error))

                        } else {

                        }
                    })
                } else {
                    // Manejar otros errores aquí
                    console.log(error);
                }
            });
    }




    const uploadItem = (title, category, subtitle, author, date, hour, related, tags, cover, enabled ) => {
        setUploading(true)
        setTimeout(() => {
            setUploading(false)
        }, 3000);
        if (
            (category !== null)
        ) {
            setAdded(true)

            // const tagsObj = itemsArr.reduce((acc, currentItem, index) => {
            //     const key = `item${index + 1}`;
            //     acc[key] = currentItem;
            //     return acc;
            // }, {});


                setDoc(doc(db, "articles", {
                    category: category,
                    title: title,
                    subtitle: subtitle,
                    author: author,
                    date: date,
                    hour: hour,
                    related: "relatedObj",
                    enabled: true,
                    cover: cover,    
                    tags: "tagsObj",
                    position: "position",
      

                }))
        } else {
            setAddError(true)

            setTimeout(() => {
                setAddError(false)
            }, 2000);
        }

    }



    return (
        <AdminContext.Provider value={{
            handleUploadShopImage,
            uploadItem
        }}>
            {children}

        </AdminContext.Provider>
    )

}

export default AdminContextProvider